import { WorkflowState } from "@/models/workflow-state";
import { Insight } from "./insight";
import { TechnicalScreeningClass } from "@/modules/slides/models/slide.models";

export interface ISlide {
  slideId: string;
  id?: string;
  scanner: string;
  date: string;
  magnification: number;
  stain: string;
  subTissue?: string;
  logicalName: string;
  alerts: {
    alertId: string;
    alertType: string;
    confidence: number;
    resolution: string;
    comments: string;
    location: any;
  }[];
  status: string;
  scores: {
    scoreId: string;
    scoreType: string;
    scoreValue: number;
  }[];
  systemStatus: string;
  workflowState: WorkflowState;
  screeningClass: any;
  confirmed: boolean;
  pois: {
    "Y Coordinate": number;
    "POI ID": number;
    "X Coordinate": number;
    "Zoom Level": number;
    "Normalized Score": number;
    "POI Type": string;
    "POI Order": number;
    "Slide Name": string;
  }[];
  thumbs: {
    label: string;
    macro: string;
    thumbnail: string;
    combo: string;
  };
  insights: Insight[];
}
export const TechnicalScreeningClasses = [
  // TechnicalScreeningClass.ERROR_DATA,
  // TechnicalScreeningClass.NOT_READY_DATA,
  TechnicalScreeningClass.OUT_OF_FOCUS,
  TechnicalScreeningClass.INADAQUATE_TISSUE,
  // TechnicalScreeningClass.IHC,
];
